import React from 'react';
import { Button, PageHeader } from 'components';
import {
  Form,
  Input,
  Select,
  DatePicker,
  Spin,
  Card,
  Row,
  Col,
  Table,
} from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useFootfalls from '../useFootfalls';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';
import FormHelper from '../../../../../helpers/FormHelper';
import styles from './style.module.scss';

const { Option } = Select;

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const {
    form,
    handleCreateOrUpdate,
    loading,
    shoppingCenters,
    singleData,
    groupData,
    columnsV2,
    tableData,
  } = useFootfalls(
    false,
    searchParams.get('day'),
    searchParams.get('shopping_center_id'),
  );

  const onFinish = async (values) => {
    if (searchParams.get('day')) {
      await handleCreateOrUpdate(
        { ...values },
        searchParams.get('day'),
        searchParams.get('shopping_center_id'),
      );
    } else {
      await handleCreateOrUpdate({
        ...values,
        day: moment(values.day).format('YYYY-MM-DD'),
      });
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const title = isNew ? t('CREARE FOOTFALL') : t('Data');

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {/* <Card>
            <Form
              form={form}
              name='basic'
              wrapperCol={{ span: 8 }}
              initialValues={{
                shopping_center_id: '',
                day: '',
                visitors: '',
              }}
              layout={isNew ? 'vertical' : 'horizontal'}
              onFinishFailed={onFinishFailed}
              onFinish={onFinish}
              autoComplete='off'
              onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
            >
              {!isNew &&
                Array.isArray(singleData) &&
                singleData.map((i, index) => (
                  <Form.Item
                    key={index}
                    label={i.day && moment(i.day).format('DD MMMM YYYY')}
                    name={i.id}
                    wrapperCol={{ span: 6 }}
                  >
                    <Input />
                  </Form.Item>
                ))}
              {isNew && (
                <>
                  <Form.Item
                    label={t('Outlet Village')}
                    name={'shopping_center_id'}
                    wrapperCol={{ span: 6 }}
                  >
                    <Select
                      placeholder={t('Outlet Village')}
                      style={{ width: '100%' }}
                    >
                      <Option value=''>{t('Selezioni opzione')}</Option>
                      {shoppingCenters.map((i) => (
                        <Option value={i.id}>{i.title}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label={t('Giorno')}
                    name={'day'}
                    wrapperCol={{ span: 6 }}
                  >
                    <DatePicker
                      format={'DD MMMM YYYY'}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={t('Visitatori')}
                    name={'visitors'}
                    wrapperCol={{ span: 6 }}
                  >
                    <Input type={'number'} />
                  </Form.Item>
                </>
              )}
            </Form>
          </Card> */}

          <Row gutter={24}>
            <Col span={24}>
              <Table
                style={{ width: '100%' }}
                columns={columnsV2}
                dataSource={tableData}
                pagination={false}
                rowKey='key'
              />
            </Col>
          </Row>
        </Spin>
        {/* <Button
          onClick={handleCreate}
          loading={loading}
          width={'150px'}
          big
          icon={<CheckOutlined />}
        >
          {t('Invia')}
        </Button> */}
      </div>
    </div>
  );
};

export default Edit;
